import { urls } from '@api/urls.ts';

const getCacheKeys = (cache: any): string[] => {
  if (!cache) return [];
  if (typeof cache.keys === 'function') {
    return Array.from(cache.keys()) as string[];
  }
  if (cache instanceof Map) {
    return Array.from(cache.keys()) as string[];
  }
  if (cache._cache && cache._cache instanceof Map) {
    return Array.from(cache._cache.keys()) as string[];
  }
  return [];
};

export const getMyDocumentsCacheKeys = (cache: any): string[] => {
  const keys = getCacheKeys(cache);
  const pattern = new RegExp(
    urls.myDocuments.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );
  return keys.filter((key) => typeof key === 'string' && pattern.test(key));
};

export const updateMyDocumentsCache = (
  cache: any,
  mutate: (key: any, data?: any, opts?: any) => Promise<any>,
  updater: (current: any) => any
) => {
  getMyDocumentsCacheKeys(cache).forEach((key) => {
    mutate(key, updater, { revalidate: false });
  });
};
